// Color palette
export const COLORS = {
  vaniglia: '#F5EDE0',
  redwine: '#722F37',
  navy: '#1E3A5F',
  gold: '#D4A017',
  sage: '#A8C4B8',
  nero: '#1a1a1a',
};

// Logo URLs
export const LOGOS = {
  white: 'https://customer-assets.emergentagent.com/job_gusto-libero/artifacts/2qt77m46_LOGO_BIANCO_orizzontale_Lola_la_liberta%E2%95%A0%C3%87_03.png',
  vanilla: 'https://customer-assets.emergentagent.com/job_gusto-libero/artifacts/gf4u7pji_LOGO_VANILLA_orizzontale_Lola_la_liberta%E2%95%A0%C3%87_03.png',
  nero: 'https://customer-assets.emergentagent.com/job_gusto-libero/artifacts/8jj64fvg_LOGO_NERO_orizzontale_Lola_la_liberta%E2%95%A0%C3%87_03.png',
};

// Images
export const IMAGES = {
  hero: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/7c6y4576_image.png',
  restaurant: 'https://images.unsplash.com/photo-1713375094006-5a0d705a2c8a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxpdGFsaWFuJTIwcmVzdGF1cmFudCUyMGludGVyaW9yJTIwd2FybSUyMGF0bW9zcGhlcmV8ZW58MHx8fHwxNzc1NzQzOTM4fDA&ixlib=rb-4.1.0&q=85',
  buffet: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/uxpxvh7x_image.png',
  pasta: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/w34p6x6u_image.png',
  food: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/plxcdy4a_image.png',
  dessert: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/dh979dok_image.png',
  bologna: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/ol4eoj1n_image.png',
  // Home "Come Funziona" step images (used only in Home.js stepImages)
  stepInterior: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/a3rff658_image.png',
  stepWeighing: 'https://customer-assets.emergentagent.com/job_web-import/artifacts/238zibsv_image.png',
};

// URLs
export const BOOKING_URL = 'https://pnssm.pro/8yz5f2r';
export const GOOGLE_MAPS_LINK = 'https://www.google.com/maps/place/Via+Jacopo+della+Quercia,+2%2F2D,+40128+Bologna+BO,+Italy';

// Animation variants
export const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] } }
};

export const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 0.8, ease: 'easeOut' } }
};

export const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.12, delayChildren: 0.1 }
  }
};

export const scaleIn = {
  hidden: { opacity: 0, scale: 0.92 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.7, ease: [0.25, 0.46, 0.45, 0.94] } }
};
